// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/eye.js';

import { paths } from '../generated/eye';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('eye', Original, paths);
